import { toast } from 'react-toastify'
import * as TABLAS from '../../../../config/tables'
import { pdfCustomToolbarGenerator } from '../../../../models/tools/generarPdf'
import * as COLUMNAS from './constantes'
import Calidad from '../../../../models/stock/calidad'
import moment from 'moment'
import { getFormValues } from 'redux-form'
import { FORM_ARCHIVO_ANALISIS } from '../../../../config/forms'

const stockCalidad = new Calidad()

export function parseData (data) {
  const parsedData = []
  if (data && data.length > 0) {
    data.map((entry) => {
      return parsedData.push({ ...entry, detalle: entry })
    })
  }
  return parsedData
}

export function actualizarDatosTabla (
  tablaId,
  funct,
  titulo,
  columnas,
  columnasToPrint,
  orientacionPdf,
  anio,
  mes) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    const fechaConsulta = `${mes} de ${anio}`
    const tituloPdf = `${titulo}: ${fechaConsulta}`

    funct(anio, mes)
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          columnasToPrint,
          orientacionPdf
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: tablaId
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerTotalMercaderiaSinAnalisis (anio, mes) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_TOTAL_SIN_ANALISIS,
      stockCalidad.getTotalMercaderiaSinAnalisis,
      'Total de cargas entrantes sin analisis',
      COLUMNAS.COL_TOTAL_SIN_ANALISIS,
      COLUMNAS.TOTAL_SIN_ANALISIS_TO_PRINT,
      'portrait',
      anio,
      mes
    ))
  }
}

export function obtenerMercaderiaSinAnalisis (anio, mes) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_MERCADERIA_SIN_ANALISIS,
      stockCalidad.getMercaderiaSinAnalisis,
      'Cargas entrantes sin analisis',
      COLUMNAS.COL_MERCADERIA_SIN_ANALISIS,
      COLUMNAS.SIN_ANALISIS_TO_PRINT,
      'portrait',
      anio,
      mes
    ))
  }
}

export function actualizarDatosCalidad (
  tablaId,
  funct,
  titulo,
  columnas,
  columnasToPrint,
  orientacionPdf,
  fechaDesde,
  fechaHasta,
  exportador,
  cereal) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    const fechaConsulta = (fechaD === fechaH)
      ? ` del dia ${moment(fechaD).format('DD-MM-YYYY')}`
      : ` entre el ${moment(fechaD).format('DD-MM-YYYY')} y el ${moment(fechaH).format('DD-MM-YYYY')}`

    const tituloPdf = `${titulo}: ${fechaConsulta}`

    funct(fechaD, fechaH, cereal, exportador)
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          columnasToPrint,
          orientacionPdf
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: tablaId
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function actualizarTotalMercaderiaEmbarcada (fechaDesde, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosCalidad(
      TABLAS.TABLA_CALIDAD_EMBARQUE_TOTAL,
      stockCalidad.getCalidadMercaderiaEmbarcadaTotal,
      'Totales calidad',
      COLUMNAS.COL_CALIDAD_EMBARQUE_TOTAL,
      COLUMNAS.CALIDAD_EMBARQUE_TOTAL_TO_PRINT,
      'portrait',
      fechaDesde,
      fechaHasta,
      exportador,
      cereal
    ))
  }
}

export function actualizarDatosMercaderiaEmbarcada (fechaDesde, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosCalidad(
      TABLAS.TABLA_CALIDAD_EMBARQUE,
      stockCalidad.getCalidadMercaderiaEmbarcada,
      'Detalle de calidad de mercadería embarcada',
      COLUMNAS.COL_CALIDAD_EMBARQUE,
      COLUMNAS.CALIDAD_EMBARQUE_TO_PRINT,
      'portrait',
      fechaDesde,
      fechaHasta,
      exportador,
      cereal
    ))
  }
}

export function actualizarDatosPorFecha (
  tablaId,
  funct,
  titulo,
  columnas,
  columnasToPrint,
  orientacionPdf,
  textRowCount,
  fechaDesde,
  fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    const fechaConsulta = (fechaD === fechaH)
      ? ` del dia ${moment(fechaD).format('DD-MM-YYYY')}`
      : ` entre el ${moment(fechaD).format('DD-MM-YYYY')} y el ${moment(fechaH).format('DD-MM-YYYY')}`

    const tituloPdf = `${titulo}: ${fechaConsulta}`

    funct(fechaD, fechaH)
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          columnasToPrint,
          orientacionPdf
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px',
              showRowCount: true,
              textRowCount
            }
          },
          id: tablaId
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function actualizarDatosControlDeGrado (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosPorFecha(
      TABLAS.TABLA_CONTROL_DE_GRADO,
      stockCalidad.getControldeGrado,
      'Cartas de porte con diferencia en el cálculo de grado',
      COLUMNAS.COL_CONTROL_DE_GRADO,
      COLUMNAS.CONTROL_DE_GRADO_TO_PRINT,
      'portrait',
      'Cantidad de cartas de porte',
      fechaDesde,
      fechaHasta
    ))
  }
}

export function actualizarDatosControlDeRebajas (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosPorFecha(
      TABLAS.TABLA_CONTROL_DE_REBAJAS,
      stockCalidad.getControlDeRebajasPorFecha,
      'Cartas de porte con diferencia en el cálculo de rebajas',
      COLUMNAS.COL_CONTROL_DE_REBAJAS,
      COLUMNAS.CONTROL_DE_REBAJAS_TO_PRINT,
      'landscape',
      'Cantidad de cartas de porte',
      fechaDesde,
      fechaHasta
    ))
  }
}

export function actualizarDatosParaSolicitudAnalisis (fechaDesde, fechaHasta) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_ARCHIVO_ANALISIS)(state)
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_SOLICITUD_ANALISIS
    })

    console.log('formvalues ', formValues)

    const titulo = 'Cartas de porte para solicitud de analisis'

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    const fechaConsulta = (fechaD === fechaH)
      ? ` del dia ${moment(fechaD).format('DD-MM-YYYY')}`
      : ` entre el ${moment(fechaD).format('DD-MM-YYYY')} y el ${moment(fechaH).format('DD-MM-YYYY')}`

    const tituloPdf = `${titulo}: ${fechaConsulta}`

    stockCalidad.getDatosSolicituAnalisis(fechaD, fechaH, formValues).then((d) => {
      const data = parseData(d)
      const customToolbar = pdfCustomToolbarGenerator(
        tituloPdf,
        data,
        COLUMNAS.SOLICITUD_ANALISIS_TO_PRINT,
        'landscape'
      )
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNAS.COL_SOLICITUD_ANALISIS,
          data: data,
          title: titulo,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '499px'
          }
        },
        id: TABLAS.TABLA_SOLICITUD_ANALISIS
      })
    })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}
